import { Web3Provider } from "@ethersproject/providers";
import { useWeb3React as _useWeb3React } from "@web3-react/core";

export function useWeb3React() {
  return _useWeb3React<Web3Provider>();
}
